// extracted by mini-css-extract-plugin
var _1 = "q7k3n";
var _2 = "KIkM6";
export { _1 as "back", _2 as "name" }
